import React from 'react';
type DecorProps = {
  className?: string;
};
const eyeStyle = {
  fill: 'rgb(var(--brand-violet))'
};
export function Pumpkin({
  className = ''
}: DecorProps) {
  return <svg viewBox="0 0 64 64" fill="currentColor" className={className} aria-hidden="true" data-id="element-100" data-mp="13qjmenmyot83">
      <path d="M30 14V9c0-3 2-5 6-6l1 3c-2 1-3 2-3 4v4z" style={{
      fill: 'rgb(var(--brand-ink) / 0.6)'
    }} data-id="element-101" data-mp="yv4eecbmxrjl" />
      <ellipse cx="21" cy="38" rx="14" ry="19" data-id="element-102" data-mp="psmtc17pv4y6" />
      <ellipse cx="43" cy="38" rx="14" ry="19" data-id="element-103" data-mp="ptekmzua6gin" />
      <ellipse cx="32" cy="38" rx="12" ry="21" data-id="element-104" data-mp="l1wjaaocidx5" />
    </svg>;
}
export function Ghost({
  className = ''
}: DecorProps) {
  return <svg viewBox="0 0 64 64" fill="currentColor" className={className} aria-hidden="true" data-id="element-105" data-mp="g20isleux4mc">
      <path d="M32 6C19 6 12 16 12 28v28l6-5 7 5 7-5 7 5 7-5 6 5V28C52 16 45 6 32 6z" data-id="element-106" data-mp="b48ojkqqp6ez" />
      <ellipse cx="25" cy="28" rx="3" ry="4" style={eyeStyle} data-id="element-107" data-mp="64dytkipamvi" />
      <ellipse cx="39" cy="28" rx="3" ry="4" style={eyeStyle} data-id="element-108" data-mp="66qefr0zkl5e" />
    </svg>;
}
export function Bat({
  className = ''
}: DecorProps) {
  return <svg viewBox="0 0 64 40" fill="currentColor" className={className} aria-hidden="true" data-id="element-109" data-mp="1553kb4mxnne4">
      <path d="M32 12c-2 0-3 1.5-3 1.5L27 9l-1 6C20 9 11 8 2 12c5 2 7 6 7 10 4-3 9-2 11 1 2-3 6-3 8 0 0 0 1-2 4-2s4 2 4 2c2-3 6-3 8 0 2-3 7-4 11-1 0-4 2-8 7-10-9-4-18-3-24 3l-1-6-2 4.5S34 12 32 12z" data-id="element-110" data-mp="19vaa37t6ldxy" />
    </svg>;
}
export function Star({
  className = ''
}: DecorProps) {
  return <svg viewBox="0 0 64 64" fill="currentColor" className={className} aria-hidden="true" data-id="element-111" data-mp="103nyvbgufev7">
      <path d="M32 4l7 20h21L43 37l6 21-17-13-17 13 6-21L4 24h21z" data-id="element-112" data-mp="1nt8mi7nxz0at" />
    </svg>;
}